export enum DirectusErrorCode {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVALID_PAYLOAD = 'INVALID_PAYLOAD',
  INVALID_RESPONSE = 'INVALID_RESPONSE',
  INVALID_API_RESPONSE = 'INVALID_API_RESPONSE',
  FAILED_VALIDATION = 'FAILED_VALIDATION',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  NOT_FOUND = 'NOT_FOUND',

  // Custom error codes
  DUPLICATE_INVITE = 'DUPLICATE_INVITE',
  INVALID_STATUS_TRANSITION = 'INVALID_STATUS_TRANSITION',
  INCOMPLETE_JOB_DATA = 'INCOMPLETE_JOB_DATA',
  NOTHING_TO_DO = 'NOTHING_TO_DO',
  MISSING_CONFIG = 'MISSING_CONFIG',
  NETWORK_ERROR = 'NETWORK_ERROR',
  PAYMENT = 'PAYMENT',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  CONFLICT = 'CONFLICT',
  unknown = 'unknown',
}

export enum LoginError {
  UNAUTHORIZED = 'UNAUTHORIZED',
  REGISTRATION_FAILED = 'REGISTRATION_FAILED',
}

export enum LoginInfo {
  REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS',
}

export enum ResetInfo {
  START_PASSWORD_RESET_FLOW_SUCCESS = 'START_PASSWORD_RESET_FLOW_SUCCESS',
}
